
import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import ProjectMixin from '@/_mixins/project'

import SortTableHeader from '@/components/SortTableHeader/SortTableHeader.vue'

import TableRow from '@/views/Project/Observation/components/tableRow.vue'
import { observationIcons } from '@/types/observation'

@Component({
    components: { SortTableHeader, TableRow },
    mixins: [ProjectMixin],
})
export default class TableView extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop() observations!: Array<any>

    // GENERAL VARIABLES
    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get observationIcons() {
        return observationIcons
    }

    get observationFilter() {
        return this.$store.getters.observationFilter
    }

    get observationSort() {
        return this.$store.getters.observationSort
    }

    get observationLayout() {
        return this.$store.getters.observationLayout
    }

    // TOGGLE OBSERVATION LIST
    get observationColumns() {
        return this.$store.getters.observationColumns
    }

    get observationColumnsArray() {
        return this.$store.getters.observationColumnsArray
    }

    set observationColumnsArray(data: any) {
        this.$store.commit('observationColumnsArray', data)
    }

    isHidden(name: string) {
        return this.observationColumnsArray.includes(name)
    }

    get permissions() {
        return this.project
            ? this.$store.getters.project(this.project.id)?.attributes.permissions
            : this.getGroupPermissions(this.group)
    }

    // FILTER BY SEARCH TERMS
    setSearchTerm(data: any) {
        let obj = JSON.parse(JSON.stringify(this.observationFilter))
        obj.filter.searchTerm = data
        this.$store.commit('observationFilter', obj)
    }
}
